(() => {
  function initializeShell(scope = document) {
    scope.querySelectorAll('[data-smid-shell]').forEach((shell) => {
      if (shell.dataset.smidShellReady) return;
      shell.dataset.smidShellReady = 'true';
      const dialog = shell.querySelector('dialog');
      const opener = shell.querySelector('[data-smid-menu-open]');
      const closeButton = shell.querySelector('[data-smid-menu-close]');
      if (dialog && opener && closeButton) {
        const close = () => { if (dialog.open) dialog.close(); };
        opener.addEventListener('click', () => {
          dialog.showModal();
          opener.setAttribute('aria-expanded', 'true');
          document.documentElement.classList.add('smid-design-menu-open');
          closeButton.focus();
        });
        closeButton.addEventListener('click', close);
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) {
            const bounds = dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
          }
          if (event.target.closest('a[href]')) close();
        });
        dialog.addEventListener('close', () => {
          opener.setAttribute('aria-expanded', 'false');
          document.documentElement.classList.remove('smid-design-menu-open');
          opener.focus();
        });
        window.matchMedia('(min-width: 1101px)').addEventListener('change', (event) => { if (event.matches) close(); });
      }
      const dropdowns = Array.from(shell.querySelectorAll('.smid-shell-dropdown'));
      dropdowns.forEach((details) => {
        let closeTimer;
        details.addEventListener('toggle', () => {
          if (details.open) dropdowns.forEach((other) => { if (other !== details) other.open = false; });
        });
        details.addEventListener('pointerenter', () => {
          clearTimeout(closeTimer);
          if (matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1101px)').matches) details.open = true;
        });
        details.addEventListener('pointerleave', () => {
          if (matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1101px)').matches) closeTimer = setTimeout(() => {
            if (!details.contains(document.activeElement) || !document.activeElement.matches(':focus-visible')) details.open = false;
          }, 150);
        });
        details.querySelector('summary')?.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            details.open = true;
            details.querySelector('a')?.focus();
          }
        });
      });
      shell.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const openDropdown = dropdowns.find((details) => details.open);
        if (openDropdown) {
          event.preventDefault();
          event.stopPropagation();
          openDropdown.open = false;
          openDropdown.querySelector('summary')?.focus();
        }
      });
      document.addEventListener('click', (event) => dropdowns.forEach((details) => {
        if (details.open && !details.contains(event.target)) details.open = false;
      }));
      shell.addEventListener('focusout', (event) => dropdowns.forEach((details) => {
        if (details.open && event.relatedTarget && !details.contains(event.relatedTarget)) details.open = false;
      }));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeShell());
  else initializeShell();
  document.addEventListener('shopify:section:load', (event) => initializeShell(event.target));
})();
